// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ReactNative from "react-native";
import * as Blocks__Common from "./common/Blocks__Common.bs.js";
import * as Renderer__Context from "@pageblocks/renderer/src/Renderer__Context.bs.js";
import * as Renderer__Version from "@pageblocks/renderer/src/Renderer__Version.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Renderer__Settings from "@pageblocks/renderer/src/Renderer__Settings.bs.js";
import * as Utils__SimpleReact from "@pageblocks/utils/src/simpleReact/Utils__SimpleReact.bs.js";
import * as Blocks__SettingsRnAdapter from "./utils/Blocks__SettingsRnAdapter.bs.js";

var blockCode = "scroll";

function makeContainerStyleFromSettings(settings, context) {
  var getFloat = function (code) {
    return Renderer__Settings.getFloat(settings, code, context);
  };
  var tmp = {};
  var tmp$1 = getFloat("flex");
  if (tmp$1 !== undefined) {
    tmp.flex = tmp$1;
  }
  var tmp$2 = Core__Option.map(getFloat("zIndex"), (function (prim) {
          return prim | 0;
        }));
  if (tmp$2 !== undefined) {
    tmp.zIndex = tmp$2;
  }
  return [
          Blocks__SettingsRnAdapter.Style.sizing(settings, context),
          Blocks__SettingsRnAdapter.Style.padding(settings, context),
          Blocks__SettingsRnAdapter.Style.margin(settings, context),
          tmp
        ];
}

function makeContentContainerStyleFromSettings(settings, context) {
  return [
          Blocks__SettingsRnAdapter.Style.flex(settings, context, true, false),
          Blocks__SettingsRnAdapter.Style.background(settings, context),
          Blocks__SettingsRnAdapter.Style.sizing(settings, context),
          Blocks__SettingsRnAdapter.Style.padding(settings, context),
          Blocks__SettingsRnAdapter.Style.border(settings, context),
          Blocks__SettingsRnAdapter.Style.position(settings, context)
        ];
}

function Blocks__Scroll$Component(props) {
  var __context = props.context;
  var context = __context !== undefined ? Caml_option.valFromOption(__context) : Renderer__Context.makeEmpty();
  var settings = Renderer__Settings.deserialize(props.settings);
  var getString = function (code) {
    return Renderer__Settings.getString(settings, code, context);
  };
  return JsxRuntime.jsx(ReactNative.ScrollView, {
              contentContainerStyle: Caml_option.some(makeContentContainerStyleFromSettings(settings, context)),
              horizontal: Core__Option.map(getString("orientation"), (function (orientation) {
                      return orientation === "horizontal";
                    })),
              nestedScrollEnabled: true,
              style: Caml_option.some(makeContainerStyleFromSettings(settings, context)),
              testID: props.testID,
              children: Caml_option.some(Utils__SimpleReact.renderIfSome(props.children, (function (children) {
                          return children;
                        })))
            });
}

var Component = {
  make: Blocks__Scroll$Component
};

var descriptor_meta = {
  version: 1,
  minRendererVersion: Renderer__Version.current
};

var descriptor_declaredTriggers = [{
    code: "onScrollEnd",
    name: "On Scroll End"
  }];

var descriptor_declaredSettings = [
  Blocks__Common.layoutSettingGroup,
  Blocks__Common.paddingSettingGroup,
  Blocks__Common.marginSettingGroup,
  Blocks__Common.sizingSettingGroup,
  Blocks__Common.backgroundSettingGroup,
  Blocks__Common.borderSettingGroup,
  Blocks__Common.opacitySettingGroup,
  Blocks__Common.absoluteLayoutSettingGroup
];

var descriptor = {
  meta: descriptor_meta,
  code: blockCode,
  component: Component,
  declaredTriggers: descriptor_declaredTriggers,
  declaredSettings: descriptor_declaredSettings
};

var version = 1;

var minRendererVersion = Renderer__Version.current;

export {
  blockCode ,
  version ,
  minRendererVersion ,
  Component ,
  descriptor ,
}
/* react-native Not a pure module */
